export default function Logo({ className = '' }: { className?: string }) {
  return (
    <img
      src="https://storage.readdy-site.link/project_files/1703dfa8-dfde-4452-8aaf-b0015a495e07/0b1afceb-7f32-4e3e-9a49-0bc0ae8019a2_compressed_propertyGrowth_Final-2.webp"
      alt="PropertyGrowth"
      className={`h-16 md:h-20 w-auto object-contain ${className}`}
    />
  );
}